module.exports = __webpack_public_path__ + "img/tag.1af1854b.svg";